enum Presets {
  TODAY = 'Hoje',
  YESTERDAY = 'Ontem',
  LAST_7_DAYS = 'Últimos 7 dias',
  LAST_30_DAYS = 'Últimos 30 dias',
  THIS_MONTH = 'Este mês',
  LAST_MONTH = 'Último mês',
}

export { Presets };
